import BriidgeTheGapLogo from '@/assets/branding/briidgethegap/BriidgeTheGapLogo.png';

export default {
  name: 'Briidge The Gap',
  isSAML: true,
  allowPersonalCourses: false,
  logo: BriidgeTheGapLogo,
  colors: {
    // Brand colors
    brand_primary: '#0C33C1',
    brand_primary_hover: '#08227F', // −10 L, −8 S
    brand_primary_highlight: '#4767FF', // +23 L, +7 S
    brand_primary_mid: '#163FD9', // +8 L,  +2 S
    brand_primary_dark: '#02071F', // −25 L, −3 S (clamped)
    brand_secondary: '#071634', // hue +4°, −15 L, −13 S
  },
};
